SupportBasePresentation = require('./base')
SupportPresenterUtilPresentation = require('./presenter_util')
SupportGoodsShippingStatusAndNotesPresentation = require('./goods_shipping_messages')

class SupportGoodsShippingPresenterPresentation extends SupportBasePresentation
  ###
  This function aims to get the lookup key for messages lookup for goods.
  The lookup key should be constructed in the sequence GOODS$$<<editabfle>>$$<<status>>$$..
  ###
  getLookupKeySequence: () ->
    keys = []

    if @order?
      keys.push(SupportPresenterUtilPresentation::getEditableKey(@order.isEditable))
      if @order.isEditable
        @addReturnableKeys(@order, keys)
      else if @shouldUseFulfillmentInfo()
        keys.push(SupportPresenterUtilPresentation::getShipmentStatusKey(@order))
        keys.push(SupportPresenterUtilPresentation::getFulfillmentMethodKey(@order))
      else
        @addReturnableKeys(@order, keys)

      SupportPresenterUtilPresentation::concatenateLookupKeys(keys)

  shouldUseFulfillmentInfo: () ->
    @order.STATE isnt 'REFUNDED' && @order.shipmentDetails?.SHIPMENT_STATE && @order.shipmentDetails.SHIPMENT_STATE isnt 'ORDER_CANCELLED'

  getLookupObject: () ->
    SupportGoodsShippingStatusAndNotesPresentation

  addReturnableKeys: (order, keys) ->
    isReturnable = SupportPresenterUtilPresentation::isReturnable(order)
    keys.push(SupportPresenterUtilPresentation::getStatusKey(order))
    keys.push(SupportPresenterUtilPresentation::getShipmentKey(order))
    keys.push(SupportPresenterUtilPresentation::getReturnableKey(isReturnable))
    keys.push(SupportPresenterUtilPresentation::getReturnabilityLabelPrintingStatus(order))

module.exports = SupportGoodsShippingPresenterPresentation
